module.exports = __webpack_public_path__ + "img/nt54-01-80-1.prt.c7c8757d.jpg";